<template>
  <div class="single-input" v-if="isInputShowNow">
    <input type="radio" name="canuse" :id="disCoupon.grno"  :value="disCoupon.grno" v-model="disCouponsId"/>
    <label :for="disCoupon.grno">
      <p class="title">{{ theResponseCoupon.RebateName }}</p>
      <p>
        可折抵
        <span class="money">${{ theResponseCoupon.DiscAmnt }}元</span>
      </p>
      <div class="date-row">
        <p>折價券使用期間</p>
        <p class="date">{{ startDate}} ~ {{ endDate}}</p>
      </div>
    </label>
  </div>
</template>

<script>
import discountApi from '@/api/discount';
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
export default {
  props: {
    disCoupon: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    productIndex: {
      type: Number,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      theResponseCoupon: '',
      unUseQty: this.disCoupon.unuseQty,
      //從API得到的折抵金額
      discAmnt: '',
      copu_type: '',
      SkuNo10: '',
      ReturnSkuNo10: '',
      DiscType10: '',
      Grno10: '',
      rebateName10: '',
      isInputShow:false
    };
  },
  created() {
    if (this.disCoupon.grno.length > 0) {
      discountApi.queryCrmcoup(
        {
          CompanyID: this.product.ClassBranchId.slice(0, 1) + '0',
          BranchId: this.product.BranchRoomID.slice(0, 4),
          ClassAmnt: this.product.price*this.product.quantity,
          OrderCnt: this.product.quantity,
          DiscSku: this.disCoupon.grno,
          DiscupType: 10,
          skipSetApiStatus: true
        },
        res => {
          this.theResponseCoupon = res;
          this.DiscAmnt = res.DiscAmnt;
          this.copu_type = 10;
          this.SkuNo10 = res.Skuno;
          this.ReturnSkuNo10 = res.ReturnSkuno;
          this.DiscType10 = res.DiscType;
          this.Grno10 = res.Grno;
          this.rebateName10 = res.RebateName;
        },
        () => {}
      );
    }
    
  },
  mounted(){
    this.setIsInputShow();
  },
  methods: {
    handleHide() {
      this.$refs.modal.hide();
    },

     setIsInputShow(){
      if(this.theResponseCoupon && this.unUseQty && !this.expired && this.ticketNo){
        this.isInputShow=true
      }else{
        this.isInputShow=false
      }
    }
  },

  watch: {
    value(newVal) {
      if (newVal == this.disCoupon.grno) {
        console.log(this.theResponseCoupon.DiscAmnt);
        this.$emit('couponDis', this.theResponseCoupon.DiscAmnt);
        this.$emit('ticketNo', this.ticketNo);
        this.$emit('couponInfo',this.theResponseCoupon);
       
      }
    },
    theResponseCoupon(){
       if(this.theResponseCoupon && this.unUseQty && !this.expired && this.ticketNo){
         this.isInputShow=true
       }else{
         this.isInputShow=false
       }
    },
    isInputShow(){
      this.$emit('isShow', this.isInputShow);
    }
  },

  computed: {
    ...mapGetters('cart', ['products']),

    allProducts() {
      return this.products.filter((item, index) => {
        return index !== this.productIndex;
      });
    },

    allProductsTicketNo() {
      let arr = this.allProducts.map(item => item.ticketNo);
      return arr;
    },

    startDate() {
      return moment(this.theResponseCoupon.ValidityStartDate).format(
        'YYYY/MM/DD'
      );
    },
    endDate() {
      return moment(this.theResponseCoupon.ValidityEndDate).format(
        'YYYY/MM/DD'
      );
    },

     endDateForJudge() {
      return moment(this.theResponseCoupon.ValidityEndDate).add(1, 'day').format(
        'YYYY/MM/DD'
      );
    },

    // ticketNo() {
    //   return this.disCoupon.tickectSeqList[
    //     Math.floor(Math.random() * this.disCoupon.tickectSeqList.length)
    //   ];
    // },
    ticketNo() {
      //API返回所有的折價券序號陣列
      let listArr = this.disCoupon.tickectSeqList;
      //過濾別的product已經使用過的序號
      for (let i of this.allProductsTicketNo) {
        listArr = listArr.filter(item => {
          return item !== i;
        });
      }
      //拿到一個新的乾淨陣列,再從裡面隨機挑一個
      return listArr[Math.floor(Math.random() * listArr.length)];
    },
    

    // 判斷是否有顯示出來
    isInputShowNow(){
      if(this.theResponseCoupon && this.unUseQty && !this.expired && this.ticketNo){
        return true
      }else{    
        return false
      }
    },

    expired() {
      return moment().format('YYYY/MM/DD') > this.endDateForJudge ? true : false;
    },

    modalId() {
      return 'can_use_coupon_modal' + this.productIndex;
    },

    disCouponsId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>
